__turbopack_context__.v({
  "asterisk": "petLossReadinessPage-module-scss-module__7lrCqG__asterisk",
  "beginButton": "petLossReadinessPage-module-scss-module__7lrCqG__beginButton",
  "beginButtonWrap": "petLossReadinessPage-module-scss-module__7lrCqG__beginButtonWrap",
  "callout": "petLossReadinessPage-module-scss-module__7lrCqG__callout",
  "calloutLink": "petLossReadinessPage-module-scss-module__7lrCqG__calloutLink",
  "calloutLinks": "petLossReadinessPage-module-scss-module__7lrCqG__calloutLinks",
  "calloutLogo": "petLossReadinessPage-module-scss-module__7lrCqG__calloutLogo",
  "calloutText": "petLossReadinessPage-module-scss-module__7lrCqG__calloutText",
  "calloutTitle": "petLossReadinessPage-module-scss-module__7lrCqG__calloutTitle",
  "card": "petLossReadinessPage-module-scss-module__7lrCqG__card",
  "disclaimer": "petLossReadinessPage-module-scss-module__7lrCqG__disclaimer",
  "foster": "petLossReadinessPage-module-scss-module__7lrCqG__foster",
  "getStartedCopy": "petLossReadinessPage-module-scss-module__7lrCqG__getStartedCopy",
  "getStartedCopyTitle": "petLossReadinessPage-module-scss-module__7lrCqG__getStartedCopyTitle",
  "getStartedGrid": "petLossReadinessPage-module-scss-module__7lrCqG__getStartedGrid",
  "getStartedImageCircle": "petLossReadinessPage-module-scss-module__7lrCqG__getStartedImageCircle",
  "getStartedImageIcon": "petLossReadinessPage-module-scss-module__7lrCqG__getStartedImageIcon",
  "getStartedImageWrap": "petLossReadinessPage-module-scss-module__7lrCqG__getStartedImageWrap",
  "getStartedInputs": "petLossReadinessPage-module-scss-module__7lrCqG__getStartedInputs",
  "intro": "petLossReadinessPage-module-scss-module__7lrCqG__intro",
  "languageOption": "petLossReadinessPage-module-scss-module__7lrCqG__languageOption",
  "languageToggle": "petLossReadinessPage-module-scss-module__7lrCqG__languageToggle",
  "localeRoot": "petLossReadinessPage-module-scss-module__7lrCqG__localeRoot",
  "pageWrapper": "petLossReadinessPage-module-scss-module__7lrCqG__pageWrapper",
  "quiz": "petLossReadinessPage-module-scss-module__7lrCqG__quiz",
  "ready": "petLossReadinessPage-module-scss-module__7lrCqG__ready",
  "reference": "petLossReadinessPage-module-scss-module__7lrCqG__reference",
  "referenceAsterisk": "petLossReadinessPage-module-scss-module__7lrCqG__referenceAsterisk",
  "related": "petLossReadinessPage-module-scss-module__7lrCqG__related",
  "resultActions": "petLossReadinessPage-module-scss-module__7lrCqG__resultActions",
  "resultBadge": "petLossReadinessPage-module-scss-module__7lrCqG__resultBadge",
  "resultBody": "petLossReadinessPage-module-scss-module__7lrCqG__resultBody",
  "resultHeading": "petLossReadinessPage-module-scss-module__7lrCqG__resultHeading",
  "resultNext": "petLossReadinessPage-module-scss-module__7lrCqG__resultNext",
  "results": "petLossReadinessPage-module-scss-module__7lrCqG__results",
  "share": "petLossReadinessPage-module-scss-module__7lrCqG__share",
  "soon": "petLossReadinessPage-module-scss-module__7lrCqG__soon",
  "stacked": "petLossReadinessPage-module-scss-module__7lrCqG__stacked",
  "stepCard": "petLossReadinessPage-module-scss-module__7lrCqG__stepCard",
  "stepIcon": "petLossReadinessPage-module-scss-module__7lrCqG__stepIcon",
  "stepLabel": "petLossReadinessPage-module-scss-module__7lrCqG__stepLabel",
  "stepsGrid": "petLossReadinessPage-module-scss-module__7lrCqG__stepsGrid",
  "stepsHeading": "petLossReadinessPage-module-scss-module__7lrCqG__stepsHeading",
  "stepsSection": "petLossReadinessPage-module-scss-module__7lrCqG__stepsSection",
  "submitButton": "petLossReadinessPage-module-scss-module__7lrCqG__submitButton",
  "submitSection": "petLossReadinessPage-module-scss-module__7lrCqG__submitSection",
  "text": "petLossReadinessPage-module-scss-module__7lrCqG__text",
  "title": "petLossReadinessPage-module-scss-module__7lrCqG__title",
  "titleBold": "petLossReadinessPage-module-scss-module__7lrCqG__titleBold",
  "titleText": "petLossReadinessPage-module-scss-module__7lrCqG__titleText",
});
